<template>
  <div class="modal modal--auth" @click.stop>
    <div class="modal-card">
      <div class="modal__close" @click="$emit('close')">
        <IconRegisterClose />
      </div>
      <div class="modal-card__header">
        <h1 class="modal-card__title">Add Payment Method</h1>
      </div>
      <div class="modal-card__body">
        <p class="modal-card__message">
          You don't have a payment method connected yet. Add one to participate in auctions and place bids.
        </p>
      </div>
      <div class="modal-card__footer">
        <div class="modal-card__actions">
          <UiButton
            class="button button--size-base button--purple"
            label="Add Payment Method"
            @click="goToPaymentMethod"
          />
          <UiButton
            class="button button--size-base button--gray link"
            label="Later"
            @click="$emit('close')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconRegisterClose from '~/components/icon/register/close.vue'

const router = useRouter()

const emit = defineEmits(['close'])

const goToPaymentMethod = () => {
  emit('close')
  void router.push('/profile/settings/payment-method')
}
</script>
